import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => mergeStyleSets({
  constantMappings: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '20px 12px',
  },
  constantHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addButton: {
    alignSelf: 'flex-start',
  }
})
